export default {
    setJwt: (state, payload) => state.jwt = payload,
    setResponseMsg: (state, payload) => state.responseMsg = payload,
    setError: (state, payload) => state.error = payload,
    setIsLoading1: (state, payload) => state.isLoading1 = payload,
    setIsLoading2: (state, payload) => state.isLoading2 = payload,
    setUser: (state, payload) => state.user = payload,
    setGuestUser: (state, payload) => state.guestUser = payload,
    setUsers: (state, payload) => state.users = payload,
    setSearchedUsers: (state, payload) => state.searchedUsers = payload,
    setBroadcast: (state, payload) => state.broadcast = payload,
    setBroadcastGroup: (state, payload) => state.broadcast_group = payload,
    setBroadcastGroups: (state, payload) => state.broadcast_groups = payload,
    setBroadcasts: (state, payload) => state.broadcasts = payload,
    setApiDomain: (state, payload) => state.apiDomain = payload,
    setTable: (state, payload) => state.table = payload,
    setTables: (state, payload) => state.tables = payload,
}
